import { render, staticRenderFns } from "./ManageReservations.vue?vue&type=template&id=0650f8ee&scoped=true"
import script from "./ManageReservations.vue?vue&type=script&lang=js"
export * from "./ManageReservations.vue?vue&type=script&lang=js"
import style0 from "./ManageReservations.vue?vue&type=style&index=0&id=0650f8ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650f8ee",
  null
  
)

export default component.exports